"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8879],{

/***/ 6360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ dfpConst; }
/* harmony export */ });
/* unused harmony export adDevice */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47842);

var dfpConst = {
    /* *** Home Page slots *** */ Desk_HP_300x250: {
        name: "CNBC_Desk_HP_300x250",
        size: [
            300,
            250
        ],
        id: "div-gpt-ad-1658152940114-0"
    },
    Desk_HP_728x90: {
        name: "CNBC_Desk_HP_728x90",
        size: [
            728,
            90
        ],
        id: "div-gpt-ad-1658153000970-0"
    },
    Desk_HP_970x90: {
        name: "Large_Leaderboard",
        size: [
            970,
            90
        ],
        id: "div-gpt-ad-1661767252961-0"
    },
    Desk_HP_300x600: {
        name: "CNBC_Desk_HP_300x600",
        size: [
            300,
            600
        ],
        id: "div-gpt-ad-1658152972675-0"
    },
    Desk_HP_Ad1_970x90: {
        name: "Side_Banner_300x250",
        size: [
            300,
            250
        ],
        id: "div-gpt-ad-1722867628193-0"
    },
    Desk_HP_Ad2_970x120: {
        name: "BannerThree",
        size: [
            980,
            90
        ],
        id: "div-gpt-ad-1722843663642-0"
    },
    // Desk_HP_Ad3_970x120: {name: 'home2nd', size: [980, 90], id: 'div-gpt-ad-1722862133984-0'},
    Desk_HP_Ad3_970x120: {
        name: "HomeUnderVideoBanner",
        size: [
            1280,
            168
        ],
        id: "div-gpt-ad-1722947375047-0"
    },
    Desk_HP_SideAd2_300x250: {
        name: "HomeSideSecond",
        size: [
            300,
            250
        ],
        id: "div-gpt-ad-1722949746038-0"
    },
    // Desk_UnderArticle_1280x168: {name: 'UnderArticle_1280x168', size:  [1280, 168], id: 'div-gpt-ad-1722944218317-0'},
    Desk_UnderArticle_1280x168: {
        name: "UnderArticle_1280x168",
        size: [
            [
                1280,
                168
            ],
            [
                728,
                90
            ],
            [
                970,
                90
            ]
        ],
        id: "div-gpt-ad-1722944218317-0"
    },
    Mobile_HP300X100: {
        name: "CNBC_Mobile_HP300X100",
        size: [
            [
                300,
                100
            ],
            [
                320,
                50
            ]
        ],
        id: "div-gpt-ad-1658153321796-0"
    },
    Desk_HP_3: {
        name: "Middle_Banner_1280x168",
        size: [
            1280,
            168
        ],
        id: "div-gpt-ad-1722868797961-0"
    },
    Mobile_HP_300X600: {
        name: "CNBC_Mobile_HP_300X600",
        size: [
            300,
            600
        ],
        id: "div-gpt-ad-1658153337564-0"
    },
    Mobile_HP_300X250: {
        name: "CNBC_Mobile_HP_300X250",
        size: [
            300,
            250
        ],
        id: "div-gpt-ad-1658153351893-0"
    },
    Tab_Home_Banner2_744x98: {
        name: "Tab_Home_UnderDriver_Tab",
        size: [
            744,
            98
        ],
        id: "div-gpt-ad-1723024025671-0"
    },
    Tab_Home_Banner3_744x98: {
        name: "Tab_Home_UnderVideo_2",
        size: [
            744,
            98
        ],
        id: "div-gpt-ad-1723124713184-0"
    },
    Mob_Home_banner2_430x57: {
        name: "Mob_Home_UnderDriver",
        size: [
            430,
            57
        ],
        id: "div-gpt-ad-1723036705478-0"
    },
    Mob_Home_banner3_430x57: {
        name: "Mob_Home_UnderVideo",
        size: [
            430,
            57
        ],
        id: "div-gpt-ad-1723034518192-0"
    },
    /* *** Inner Pages slots *** */ APP_Bottom_300x250: {
        name: "CNBC_APP_Bottom_300x250",
        size: [
            300,
            250
        ],
        id: "div-gpt-ad-1658152230777-0"
    },
    // APP_Bottom_300x250: {name: 'CNBC_Mobile_Inner_Page300X250', size: [300, 250], id: 'div-gpt-ad-1664454435845-0'},
    APP_Midddle_320x50: {
        name: "CNBC_APP_Midddle_320x50",
        size: [
            [
                320,
                50
            ],
            [
                300,
                100
            ]
        ],
        id: "div-gpt-ad-1658152365520-0"
    },
    APP_TOP_300x250: {
        name: "CNBC_APP_TOP_300x250",
        size: [
            300,
            250
        ],
        id: "div-gpt-ad-1658152585209-0"
    },
    //APP_TOP_300x250: {name: 'CNBC_Mobile_HP_300X250', size: [300, 250], id: 'div-gpt-ad-1664454567752-0'},
    Desk_Between_728x90: {
        name: "CNBC_Desk_Between_728x90",
        size: [
            728,
            90
        ],
        id: "div-gpt-ad-1658152801976-0"
    },
    Desk_Between_300x600: {
        name: "CNBC_Desk_Between_300x600",
        size: [
            300,
            600
        ],
        id: "div-gpt-ad-1658152770792-0"
    },
    Desk_Between_300x250: {
        name: "CNBC_Desk_Between_300x250",
        size: [
            300,
            250
        ],
        id: "div-gpt-ad-1658152742263-0"
    },
    Desk_LiveStream_300x250: {
        name: "CNBC_Desk_LiveStream_300x250",
        size: [
            300,
            250
        ],
        id: "div-gpt-ad-1658152915490-0"
    },
    Mobile_LiveStream300x250: {
        name: "CNBC_Mobile_LiveStream300x250",
        size: [
            300,
            250
        ],
        id: "div-gpt-ad-1658153220306-0"
    },
    Mobile_Inner_Page300X600: {
        name: "CNBC_Mobile_Inner_Page300X600",
        size: [
            300,
            600
        ],
        id: "div-gpt-ad-1658153259219-0"
    },
    // Mobile_Inner_Page300X250: {name: 'CNBC_Mobile_Inner_Page300X250', size: [300, 250], id: 'div-gpt-ad-1658153281882-0'},
    Mobile_Inner_Page300X250: {
        name: "CNBC_Mobile_Inner_Page300X250",
        size: [
            [
                250,
                250
            ],
            [
                336,
                280
            ],
            [
                300,
                250
            ],
            [
                320,
                480
            ],
            [
                320,
                50
            ]
        ],
        id: "div-gpt-ad-1658153281882-0"
    },
    Mobile_Inner_Page300X100: {
        name: "CNBC_Mobile_Inner_Page300X100",
        size: [
            [
                300,
                100
            ],
            [
                320,
                50
            ]
        ],
        id: "div-gpt-ad-1658153303126-0"
    },
    CNBC_Desk_Article_End: {
        name: "CNBC_Desk_Article_End",
        size: [
            [
                336,
                280
            ],
            [
                728,
                90
            ],
            [
                300,
                250
            ]
        ],
        id: "div-gpt-ad-1745486791659-0"
    },
    CNBC_Desk_Article_End_1: {
        name: "CNBC_Desk_Article_End",
        size: [
            336,
            280
        ],
        id: "div-gpt-ad-1745486791659-0"
    },
    CNBC_Desk_Article_End_2: {
        name: "CNBC_Desk_Article_End",
        size: [
            728,
            90
        ],
        id: "div-gpt-ad-1745486791659-0"
    },
    CNBC_Desk_Article_End_3: {
        name: "CNBC_Desk_Article_End",
        size: [
            300,
            250
        ],
        id: "div-gpt-ad-1745486791659-0"
    },
    CNBC_Mobile_Article_End: {
        name: "CNBC_Mobile_Article_End",
        size: [
            [
                320,
                50
            ],
            [
                336,
                280
            ],
            [
                320,
                480
            ],
            [
                320,
                100
            ],
            [
                300,
                250
            ]
        ],
        id: "div-gpt-ad-1745486992305-0"
    },
    CNBC_Mobile_Article_End_1: {
        name: "CNBC_Mobile_Article_End",
        size: [
            320,
            50
        ],
        id: "div-gpt-ad-1745486992305-0"
    },
    CNBC_Mobile_Article_End_2: {
        name: "CNBC_Mobile_Article_End",
        size: [
            336,
            280
        ],
        id: "div-gpt-ad-1745486992305-0"
    },
    CNBC_Mobile_Article_End_3: {
        name: "CNBC_Mobile_Article_End",
        size: [
            320,
            480
        ],
        id: "div-gpt-ad-1745486992305-0"
    },
    CNBC_Mobile_Article_End_4: {
        name: "CNBC_Mobile_Article_End",
        size: [
            320,
            100
        ],
        id: "div-gpt-ad-1745486992305-0"
    },
    CNBC_Mobile_Article_End_5: {
        name: "CNBC_Mobile_Article_End",
        size: [
            300,
            250
        ],
        id: "div-gpt-ad-1745486992305-0"
    },
    slot_id: "9917026"
};
var adDevice = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    "div-gpt-ad-1658153000970-0": "d"
}, "div-gpt-ad-1658153000970-0", "m");


/***/ }),

/***/ 37993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OC": function() { return /* binding */ displayId; },
/* harmony export */   "ac": function() { return /* binding */ removeSlot; },
/* harmony export */   "dE": function() { return /* binding */ defineSlot; },
/* harmony export */   "g7": function() { return /* binding */ enableServices; }
/* harmony export */ });
/* harmony import */ var _const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6360);

var removeSlot = function removeSlot() {
    if (window) {
        var ref;
        var googletag = window.googletag;
        googletag === null || googletag === void 0 ? void 0 : (ref = googletag.cmd) === null || ref === void 0 ? void 0 : ref.push(function() {
            googletag === null || googletag === void 0 ? void 0 : googletag.destroySlots();
        });
    }
};
var defineSlot = function defineSlot(name, id) {
    var sizes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], params = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (window) {
        var googletag = window.googletag, lotaudsList = window.lotaudsList, screen = window.screen;
        (googletag === null || googletag === void 0 ? void 0 : googletag.defineSlot) && (googletag === null || googletag === void 0 ? void 0 : googletag.defineSlot("/".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.slot_id */ .r.slot_id, "/").concat(name), sizes, id).addService(googletag.pubads()));
        (googletag === null || googletag === void 0 ? void 0 : googletag.pubads) && (googletag === null || googletag === void 0 ? void 0 : googletag.pubads().setTargeting("section", params.section).setTargeting("position", params.position));
        (googletag === null || googletag === void 0 ? void 0 : googletag.pubads) && (googletag === null || googletag === void 0 ? void 0 : googletag.pubads().enableSingleRequest(false));
    }
};
var enableServices = function enableServices(id) {
    if (window) {
        var googletag = window.googletag;
        (googletag === null || googletag === void 0 ? void 0 : googletag.enableServices) && (googletag === null || googletag === void 0 ? void 0 : googletag.enableServices());
    }
};
var displayId = function displayId(id) {
    if (window) {
        var googletag = window.googletag;
        (googletag === null || googletag === void 0 ? void 0 : googletag.display) && (googletag === null || googletag === void 0 ? void 0 : googletag.display(id));
    }
};


/***/ }),

/***/ 18879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M3": function() { return /* binding */ DefineSlotsInnerPage; },
/* harmony export */   "kh": function() { return /* binding */ DefineSlotsHome; },
/* harmony export */   "n5": function() { return /* binding */ DefineSlotsLivePage; }
/* harmony export */ });
/* harmony import */ var _const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6360);
/* harmony import */ var _dfp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37993);


var GPT_SCRIPT_SRC = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
var runWhenGptReady = function(callback) {
    if (false) {}
    window.googletag = window.googletag || {
        cmd: []
    };
    window.googletag.cmd.push(callback);
    if (window.googletag.apiReady) return;
    var existingScript = document.querySelector('script[src="'.concat(GPT_SCRIPT_SRC, '"]')) || document.getElementById("gpt-loader-script");
    if (existingScript) return;
    var script = document.createElement("script");
    script.id = "gpt-loader-script";
    script.src = GPT_SCRIPT_SRC;
    script.async = true;
    document.head.appendChild(script);
};
var DefineSlotsHome = function() {
    if (true) {
        runWhenGptReady(function() {
            if ((window === null || window === void 0 ? void 0 : window.innerWidth) > 768) {
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .removeSlot */ .ac)();
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_970x90.name */ .r.Desk_HP_970x90.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_970x90.id */ .r.Desk_HP_970x90.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_970x90.size */ .r.Desk_HP_970x90.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "1"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_728x90.name */ .r.Desk_HP_728x90.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_728x90.id */ .r.Desk_HP_728x90.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_728x90.size */ .r.Desk_HP_728x90.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "1"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_300x250.name */ .r.Desk_HP_300x250.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_300x250.id */ .r.Desk_HP_300x250.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_300x250.size */ .r.Desk_HP_300x250.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "2"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_300x600.name */ .r.Desk_HP_300x600.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_300x600.id */ .r.Desk_HP_300x600.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_300x600.size */ .r.Desk_HP_300x600.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "3"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_728x90.name */ .r.Desk_Between_728x90.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_728x90.id */ .r.Desk_Between_728x90.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_728x90.size */ .r.Desk_Between_728x90.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "7"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_Ad1_970x90.name */ .r.Desk_HP_Ad1_970x90.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_Ad1_970x90.id */ .r.Desk_HP_Ad1_970x90.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_Ad1_970x90.size */ .r.Desk_HP_Ad1_970x90.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "8"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_Ad2_970x120.name */ .r.Desk_HP_Ad2_970x120.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_Ad2_970x120.id */ .r.Desk_HP_Ad2_970x120.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_Ad2_970x120.size */ .r.Desk_HP_Ad2_970x120.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "9"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_Ad3_970x120.name */ .r.Desk_HP_Ad3_970x120.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_Ad3_970x120.id */ .r.Desk_HP_Ad3_970x120.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_Ad3_970x120.size */ .r.Desk_HP_Ad3_970x120.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "12"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_3.name */ .r.Desk_HP_3.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_3.id */ .r.Desk_HP_3.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_3.size */ .r.Desk_HP_3.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "10"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Tab_Home_Banner2_744x98.name */ .r.Tab_Home_Banner2_744x98.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Tab_Home_Banner2_744x98.id */ .r.Tab_Home_Banner2_744x98.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Tab_Home_Banner2_744x98.size */ .r.Tab_Home_Banner2_744x98.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "10"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_SideAd2_300x250.name */ .r.Desk_HP_SideAd2_300x250.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_SideAd2_300x250.id */ .r.Desk_HP_SideAd2_300x250.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_SideAd2_300x250.size */ .r.Desk_HP_SideAd2_300x250.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "11"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Tab_Home_Banner3_744x98.name */ .r.Tab_Home_Banner3_744x98.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Tab_Home_Banner3_744x98.id */ .r.Tab_Home_Banner3_744x98.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Tab_Home_Banner3_744x98.size */ .r.Tab_Home_Banner3_744x98.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "10"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .enableServices */ .g7)();
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_970x90.id */ .r.Desk_HP_970x90.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_728x90.id */ .r.Desk_HP_728x90.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_300x250.id */ .r.Desk_HP_300x250.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_300x600.id */ .r.Desk_HP_300x600.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_728x90.id */ .r.Desk_Between_728x90.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_Ad1_970x90.id */ .r.Desk_HP_Ad1_970x90.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_Ad2_970x120.id */ .r.Desk_HP_Ad2_970x120.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_Ad3_970x120.id */ .r.Desk_HP_Ad3_970x120.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_3.id */ .r.Desk_HP_3.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_SideAd2_300x250.id */ .r.Desk_HP_SideAd2_300x250.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Tab_Home_Banner2_744x98.id */ .r.Tab_Home_Banner2_744x98.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Tab_Home_Banner3_744x98.id */ .r.Tab_Home_Banner3_744x98.id);
            } else {
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .removeSlot */ .ac)();
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_HP300X100.name */ .r.Mobile_HP300X100.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_HP300X100.id */ .r.Mobile_HP300X100.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_HP300X100.size */ .r.Mobile_HP300X100.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "4"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_HP_300X600.name */ .r.Mobile_HP_300X600.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_HP_300X600.id */ .r.Mobile_HP_300X600.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_HP_300X600.size */ .r.Mobile_HP_300X600.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "5"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_HP_300X250.name */ .r.Mobile_HP_300X250.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_HP_300X250.id */ .r.Mobile_HP_300X250.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_HP_300X250.size */ .r.Mobile_HP_300X250.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "6"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mob_Home_banner3_430x57.name */ .r.Mob_Home_banner3_430x57.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mob_Home_banner3_430x57.id */ .r.Mob_Home_banner3_430x57.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mob_Home_banner3_430x57.size */ .r.Mob_Home_banner3_430x57.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "11"
                });
                //defineSlot(`${dfpConst.APP_Bottom_300x250.name}`, `${dfpConst.APP_Bottom_300x250.id}`, dfpConst.APP_Bottom_300x250.size, { section: ['Homepage'], position: '6' })
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.APP_Midddle_320x50.name */ .r.APP_Midddle_320x50.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.APP_Midddle_320x50.id */ .r.APP_Midddle_320x50.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.APP_Midddle_320x50.size */ .r.APP_Midddle_320x50.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "6"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.APP_TOP_300x250.name */ .r.APP_TOP_300x250.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.APP_TOP_300x250.id */ .r.APP_TOP_300x250.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.APP_TOP_300x250.size */ .r.APP_TOP_300x250.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "6"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mob_Home_banner2_430x57.name */ .r.Mob_Home_banner2_430x57.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mob_Home_banner2_430x57.id */ .r.Mob_Home_banner2_430x57.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mob_Home_banner2_430x57.size */ .r.Mob_Home_banner2_430x57.size, {
                    section: [
                        "Homepage"
                    ],
                    position: "12"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .enableServices */ .g7)();
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_HP300X100.id */ .r.Mobile_HP300X100.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_HP_300X600.id */ .r.Mobile_HP_300X600.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_HP_300X250.id */ .r.Mobile_HP_300X250.id);
                //displayId(dfpConst.APP_Bottom_300x250.id)
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.APP_Midddle_320x50.id */ .r.APP_Midddle_320x50.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.APP_TOP_300x250.id */ .r.APP_TOP_300x250.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mob_Home_banner2_430x57.id */ .r.Mob_Home_banner2_430x57.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mob_Home_banner3_430x57.id */ .r.Mob_Home_banner3_430x57.id);
            }
        // removeSlot();
        // defineSlot(`${dfpConst.Desk_HP_970x90.name}`, `${dfpConst.Desk_HP_970x90.id}`, dfpConst.Desk_HP_970x90.size,  { section: ['Homepage'], position: '1' })
        // defineSlot(`${dfpConst.Desk_HP_728x90.name}`, `${dfpConst.Desk_HP_728x90.id}`, dfpConst.Desk_HP_728x90.size,  { section: ['Homepage'], position: '1' })
        // defineSlot(`${dfpConst.Desk_HP_300x250.name}`, `${dfpConst.Desk_HP_300x250.id}`, dfpConst.Desk_HP_300x250.size, { section: ['Homepage'], position: '2' })
        // defineSlot(`${dfpConst.Desk_HP_300x600.name}`, `${dfpConst.Desk_HP_300x600.id}`, dfpConst.Desk_HP_300x600.size, { section: ['Homepage'], position: '3' })
        // defineSlot(`${dfpConst.Mobile_HP300X100.name}`, `${dfpConst.Mobile_HP300X100.id}`, dfpConst.Mobile_HP300X100.size, { section: ['Homepage'], position: '4' })
        // defineSlot(`${dfpConst.Mobile_HP_300X600.name}`, `${dfpConst.Mobile_HP_300X600.id}`, dfpConst.Mobile_HP_300X600.size, { section: ['Homepage'], position: '5' })
        // defineSlot(`${dfpConst.Mobile_HP_300X250.name}`, `${dfpConst.Mobile_HP_300X250.id}`, dfpConst.Mobile_HP_300X250.size, { section: ['Homepage'], position: '6' })
        // defineSlot(`${dfpConst.APP_Bottom_300x250.name}`, `${dfpConst.APP_Bottom_300x250.id}`, dfpConst.APP_Bottom_300x250.size, { section: ['Homepage'], position: '6' })
        // defineSlot(`${dfpConst.APP_Midddle_320x50.name}`, `${dfpConst.APP_Midddle_320x50.id}`, dfpConst.APP_Midddle_320x50.size, { section: ['Homepage'], position: '6' })
        // defineSlot(`${dfpConst.APP_TOP_300x250.name}`, `${dfpConst.APP_TOP_300x250.id}`, dfpConst.APP_TOP_300x250.size, { section: ['Homepage'], position: '6' })
        // defineSlot(`${dfpConst.Desk_Between_728x90.name}`, `${dfpConst.Desk_Between_728x90.id}`, dfpConst.Desk_Between_728x90.size,  { section: ['Homepage'], position: '7' })
        // enableServices()
        // displayId(dfpConst.Desk_HP_970x90.id)
        // displayId(dfpConst.Desk_HP_728x90.id)
        // displayId(dfpConst.Desk_HP_300x250.id)
        // displayId(dfpConst.Desk_HP_300x600.id)
        // displayId(dfpConst.Mobile_HP300X100.id)
        // displayId(dfpConst.Mobile_HP_300X600.id)
        // displayId(dfpConst.Mobile_HP_300X250.id)
        // displayId(dfpConst.APP_Bottom_300x250.id)
        // displayId(dfpConst.APP_Midddle_320x50.id)
        // displayId(dfpConst.APP_TOP_300x250.id)
        // displayId(dfpConst.Desk_Between_728x90.id)
        });
    }
};
var DefineSlotsInnerPage = function() {
    if (true) {
        runWhenGptReady(function() {
            if ((window === null || window === void 0 ? void 0 : window.innerWidth) > 768) {
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .removeSlot */ .ac)();
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_728x90.name */ .r.Desk_Between_728x90.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_728x90.id */ .r.Desk_Between_728x90.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_728x90.size */ .r.Desk_Between_728x90.size, {
                    section: [
                        "InnerPage"
                    ],
                    position: "1"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_300x600.name */ .r.Desk_Between_300x600.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_300x600.id */ .r.Desk_Between_300x600.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_300x600.size */ .r.Desk_Between_300x600.size, {
                    section: [
                        "InnerPage"
                    ],
                    position: "2"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_300x250.name */ .r.Desk_Between_300x250.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_300x250.id */ .r.Desk_Between_300x250.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_300x250.size */ .r.Desk_Between_300x250.size, {
                    section: [
                        "InnerPage"
                    ],
                    position: "3"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_UnderArticle_1280x168.name */ .r.Desk_UnderArticle_1280x168.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_UnderArticle_1280x168.id */ .r.Desk_UnderArticle_1280x168.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_UnderArticle_1280x168.size */ .r.Desk_UnderArticle_1280x168.size, {
                    section: [
                        "InnerPage"
                    ],
                    position: "7"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.CNBC_Desk_Article_End.name */ .r.CNBC_Desk_Article_End.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.CNBC_Desk_Article_End.id */ .r.CNBC_Desk_Article_End.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.CNBC_Desk_Article_End.size */ .r.CNBC_Desk_Article_End.size, {
                    section: [
                        "InnerPage"
                    ],
                    position: "13"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .enableServices */ .g7)();
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_728x90.id */ .r.Desk_Between_728x90.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_300x600.id */ .r.Desk_Between_300x600.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_300x250.id */ .r.Desk_Between_300x250.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_UnderArticle_1280x168.id */ .r.Desk_UnderArticle_1280x168.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.CNBC_Desk_Article_End.id */ .r.CNBC_Desk_Article_End.id);
            } else {
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .removeSlot */ .ac)();
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X600.name */ .r.Mobile_Inner_Page300X600.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X600.id */ .r.Mobile_Inner_Page300X600.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X600.size */ .r.Mobile_Inner_Page300X600.size, {
                    section: [
                        "InnerPage"
                    ],
                    position: "4"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X250.name */ .r.Mobile_Inner_Page300X250.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X250.id */ .r.Mobile_Inner_Page300X250.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X250.size */ .r.Mobile_Inner_Page300X250.size, {
                    section: [
                        "InnerPage"
                    ],
                    position: "5"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X100.name */ .r.Mobile_Inner_Page300X100.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X100.id */ .r.Mobile_Inner_Page300X100.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X100.size */ .r.Mobile_Inner_Page300X100.size, {
                    section: [
                        "InnerPage"
                    ],
                    position: "6"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.APP_Bottom_300x250.name */ .r.APP_Bottom_300x250.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.APP_Bottom_300x250.id */ .r.APP_Bottom_300x250.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.APP_Bottom_300x250.size */ .r.APP_Bottom_300x250.size, {
                    section: [
                        "InnerPage"
                    ],
                    position: "7"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.CNBC_Mobile_Article_End.name */ .r.CNBC_Mobile_Article_End.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.CNBC_Mobile_Article_End.id */ .r.CNBC_Mobile_Article_End.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.CNBC_Mobile_Article_End.size */ .r.CNBC_Mobile_Article_End.size, {
                    section: [
                        "InnerPage"
                    ],
                    position: "14"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .enableServices */ .g7)();
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X600.id */ .r.Mobile_Inner_Page300X600.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X250.id */ .r.Mobile_Inner_Page300X250.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X100.id */ .r.Mobile_Inner_Page300X100.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.APP_Bottom_300x250.id */ .r.APP_Bottom_300x250.id);
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.CNBC_Mobile_Article_End.id */ .r.CNBC_Mobile_Article_End.id);
            }
        // removeSlot();
        // defineSlot(`${dfpConst.Desk_Between_728x90.name}`, `${dfpConst.Desk_Between_728x90.id}`, dfpConst.Desk_Between_728x90.size,  { section: ['InnerPage'], position: '1' })
        // defineSlot(`${dfpConst.Desk_Between_300x600.name}`, `${dfpConst.Desk_Between_300x600.id}`, dfpConst.Desk_Between_300x600.size, { section: ['InnerPage'], position: '2' })
        // defineSlot(`${dfpConst.Desk_Between_300x250.name}`, `${dfpConst.Desk_Between_300x250.id}`, dfpConst.Desk_Between_300x250.size, { section: ['InnerPage'], position: '3' })
        // defineSlot(`${dfpConst.Mobile_Inner_Page300X600.name}`, `${dfpConst.Mobile_Inner_Page300X600.id}`, dfpConst.Mobile_Inner_Page300X600.size, { section: ['InnerPage'], position: '4' })
        // defineSlot(`${dfpConst.Mobile_Inner_Page300X250.name}`, `${dfpConst.Mobile_Inner_Page300X250.id}`, dfpConst.Mobile_Inner_Page300X250.size, { section: ['InnerPage'], position: '5' })
        // defineSlot(`${dfpConst.Mobile_Inner_Page300X100.name}`, `${dfpConst.Mobile_Inner_Page300X100.id}`, dfpConst.Mobile_Inner_Page300X100.size, { section: ['InnerPage'], position: '6' })
        // defineSlot(`${dfpConst.APP_Bottom_300x250.name}`, `${dfpConst.APP_Bottom_300x250.id}`, dfpConst.APP_Bottom_300x250.size, { section: ['InnerPage'], position: '7' })
        // enableServices()
        // displayId(dfpConst.Desk_Between_728x90.id)
        // displayId(dfpConst.Desk_Between_300x600.id)
        // displayId(dfpConst.Desk_Between_300x250.id)
        // displayId(dfpConst.Mobile_Inner_Page300X600.id)
        // displayId(dfpConst.Mobile_Inner_Page300X250.id)
        // displayId(dfpConst.Mobile_Inner_Page300X100.id)
        // displayId(dfpConst.APP_Bottom_300x250.id)
        });
    }
};
var DefineSlotsLivePage = function() {
    if (true) {
        runWhenGptReady(function() {
            if ((window === null || window === void 0 ? void 0 : window.innerWidth) > 768) {
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .removeSlot */ .ac)();
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_728x90.name */ .r.Desk_Between_728x90.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_728x90.id */ .r.Desk_Between_728x90.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_728x90.size */ .r.Desk_Between_728x90.size, {
                    section: [
                        "liveTvPage"
                    ],
                    position: "1"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .enableServices */ .g7)();
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_Between_728x90.id */ .r.Desk_Between_728x90.id);
            } else {
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .removeSlot */ .ac)();
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X100.name */ .r.Mobile_Inner_Page300X100.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X100.id */ .r.Mobile_Inner_Page300X100.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X100.size */ .r.Mobile_Inner_Page300X100.size, {
                    section: [
                        "InnerPage"
                    ],
                    position: "6"
                });
                //defineSlot(`${dfpConst.APP_Bottom_300x250.name}`, `${dfpConst.APP_Bottom_300x250.id}`, dfpConst.APP_Bottom_300x250.size, { section: ['InnerPage'], position: '7' })
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .defineSlot */ .dE)("".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_LiveStream300x250.name */ .r.Mobile_LiveStream300x250.name), "".concat(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_LiveStream300x250.id */ .r.Mobile_LiveStream300x250.id), _const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Desk_HP_728x90.size */ .r.Desk_HP_728x90.size, {
                    section: [
                        "liveTvPage"
                    ],
                    position: "5"
                });
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .enableServices */ .g7)();
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_Inner_Page300X100.id */ .r.Mobile_Inner_Page300X100.id);
                //displayId(dfpConst.APP_Bottom_300x250.id)
                (0,_dfp__WEBPACK_IMPORTED_MODULE_1__/* .displayId */ .OC)(_const__WEBPACK_IMPORTED_MODULE_0__/* .dfpConst.Mobile_LiveStream300x250.id */ .r.Mobile_LiveStream300x250.id);
            }
        // removeSlot();
        // defineSlot(`${dfpConst.Desk_Between_728x90.name}`, `${dfpConst.Desk_Between_728x90.id}`, dfpConst.Desk_Between_728x90.size,  { section: ['liveTvPage'], position: '1' })
        // defineSlot(`${dfpConst.Desk_Between_300x600.name}`, `${dfpConst.Desk_Between_300x600.id}`, dfpConst.Desk_Between_300x600.size, { section: ['liveTvPage'], position: '2' })
        // defineSlot(`${dfpConst.Desk_Between_300x250.name}`, `${dfpConst.Desk_Between_300x250.id}`, dfpConst.Desk_Between_300x250.size, { section: ['liveTvPage'], position: '3' })
        // defineSlot(`${dfpConst.Desk_LiveStream_300x250.name}`, `${dfpConst.Desk_LiveStream_300x250.id}`, dfpConst.Desk_LiveStream_300x250.size, { section: ['liveTvPage'], position: '4' })
        // defineSlot(`${dfpConst.Mobile_LiveStream300x250.name}`, `${dfpConst.Mobile_LiveStream300x250.id}`, dfpConst.Desk_HP_728x90.size, { section: ['liveTvPage'], position: '5' })
        // defineSlot(`${dfpConst.Mobile_Inner_Page300X100.name}`, `${dfpConst.Mobile_Inner_Page300X100.id}`, dfpConst.Mobile_Inner_Page300X100.size, { section: ['InnerPage'], position: '6' })
        // enableServices()
        // displayId(dfpConst.Desk_Between_728x90.id)
        // displayId(dfpConst.Desk_Between_300x600.id)
        // displayId(dfpConst.Desk_Between_300x250.id)
        // displayId(dfpConst.Desk_LiveStream_300x250.id)
        // displayId(dfpConst.Mobile_LiveStream300x250.id)
        // displayId(dfpConst.Mobile_Inner_Page300X100.id)
        });
    }
};


/***/ })

}]);